/**
 * Округляет время в секундах до ближайших 15 минут
 * @param {number} seconds - время в секундах
 * @returns {number} - округленное время в секундах
 */
export const roundTimeToQuarter = (seconds) => {
  const minutes = seconds / 60;
  // Округляем до ближайших 15 минут
  return Math.round(minutes / 15) * 15 * 60;
};

/**
 * Форматирует время из секунд в формат ч:мм с округлением до 15 минут
 * @param {number} seconds - время в секундах
 * @returns {string} - отформатированное время в формате ч:мм
 */
export const formatTimeWithRounding = (seconds) => {
  const roundedSeconds = roundTimeToQuarter(seconds);
  const hours = Math.floor(roundedSeconds / 3600);
  const minutes = Math.floor((roundedSeconds % 3600) / 60);
  return `${hours}:${String(minutes).padStart(2, "0")}`;
};

/**
 * Форматирует время из часов в формат ч:мм с округлением до 15 минут
 * @param {number} hours - время в часах (может быть дробным)
 * @returns {string} - отформатированное время в формате ч:мм
 */
export const formatHoursWithRounding = (hours) => {
  return formatTimeWithRounding(hours * 3600);
};

/**
 * Безопасная обработка нулевых значений
 * Сохраняет 0 если сервер вернул 0, заменяет только null/undefined
 */
export const safeNumber = (value, defaultValue = 0) => {
  if (value === null || value === undefined) {
    return defaultValue;
  }
  return value;
};

/**
 * Безопасная обработка строковых значений
 * Сохраняет пустую строку если сервер вернул "", заменяет только null/undefined
 */
export const safeString = (value, defaultValue = "") => {
  if (value === null || value === undefined) {
    return defaultValue;
  }
  return value;
};

/**
 * Безопасная обработка объектов
 * Заменяет только null/undefined, сохраняет пустые объекты
 */
export const safeObject = (value, defaultValue = {}) => {
  if (value === null || value === undefined) {
    return defaultValue;
  }
  return value;
};

/**
 * Безопасная обработка массивов
 * Заменяет только null/undefined, сохраняет пустые массивы
 */
export const safeArray = (value, defaultValue = []) => {
  if (value === null || value === undefined) {
    return defaultValue;
  }
  return value;
};
